<section class="hero" id="hero">
  <div class="hero-bg"></div>
  <div class="container hero-content">
    <div class="hero-text">
      <p class="eyebrow">Portfolio personnel</p>
      <h1>
        <span class="hero-name">{{ identity.pseudo }}</span>
        <span class="hero-real">{{ identity.fullName }}</span>
      </h1>
      <p class="hero-title">{{ identity.title }}</p>
      <p class="hero-headline">{{ headline }}</p>
      <div class="hero-meta">
        <span>{{ identity.location }}</span>
        <span>{{ age }} ans</span>
      </div>
      <div class="hero-actions">
        <a class="btn primary" href="#contact">Me contacter</a>
        <a class="btn ghost" href="#experiences">Voir l'expérience</a>
      </div>
    </div>
    <div class="hero-card">
      <div class="hero-card-glow"></div>
      <div class="hero-card-inner">
        <p class="card-label">Signature</p>
        <p class="card-title">{{ identity.pseudo }}</p>
        <p class="card-sub">Développeur exigeant. Vision produit. Exécution premium.</p>
        <div class="card-tags">
          <span>Angular 21</span>
          <span>TypeScript</span>
          <span>UI Craft</span>
        </div>
      </div>
    </div>
  </div>
</section>
